import { FC } from "react";
import { Stack, Text } from "@chakra-ui/react";

export const MainPagePaymentScheduleAllPaid: FC = () => {
  return (
    <Stack w="78px" h="23px" mt="2px" px="8px" pt="1px" borderRadius="20px" bg="green.25">
      <Text variant="green" fontSize="10px" lineHeight="23px">
        Всё оплачено
      </Text>
    </Stack>
  );
};
